/* acrylic.studio — Estimated delivery pill + "Tell your story" carousel & lightbox.
   Vanilla JS, no dependencies. Safe to include multiple times (guarded). */
(function () {
  'use strict';
  if (window.__tysLoaded) return;
  window.__tysLoaded = true;

  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Estimated delivery ---------------- */
  // Adds n business days to `from` (local date). Day 0 = today; each following weekday counts as 1.
  function addBusinessDays(from, n, skipWeekends) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 12);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (!skipWeekends || (w !== 0 && w !== 6)) added++;
    }
    return d;
  }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function deliveryRange(from, min, max, skipWeekends) {
    var a = fmt(addBusinessDays(from, min, skipWeekends));
    var b = fmt(addBusinessDays(from, max, skipWeekends));
    return a === b ? a : a + ' - ' + b;
  }

  function initDelivery(el) {
    if (el.__tysReady) return;
    el.__tysReady = true;
    var min = Math.max(0, parseInt(el.getAttribute('data-min-days'), 10) || 0);
    var max = Math.max(min, parseInt(el.getAttribute('data-max-days'), 10) || min);
    var skip = el.getAttribute('data-skip-weekends') !== 'false';
    var out = el.querySelector('[data-tys-delivery-dates]');
    if (out) out.textContent = deliveryRange(new Date(), min, max, skip);
    el.hidden = false;
  }

  /* ---------------- Lightbox (one shared instance) ---------------- */
  var modal = null;
  function icon(path) {
    return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="' + path +
      '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function getModal() {
    if (modal) return modal;
    var el = document.createElement('div');
    el.className = 'tys-modal';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Video player');
    el.innerHTML =
      '<div class="tys-modal__count" data-tys-count aria-live="polite"></div>' +
      '<button type="button" class="tys-modal__btn tys-modal__close" data-tys-close aria-label="Close video">' + icon('M6 6l12 12M18 6L6 18') + '</button>' +
      '<button type="button" class="tys-modal__btn tys-modal__prev" data-tys-mprev aria-label="Previous video">' + icon('M15 5l-7 7 7 7') + '</button>' +
      '<div class="tys-modal__stage" data-tys-stage><video class="tys-modal__video" data-tys-mvideo playsinline controls preload="auto"></video></div>' +
      '<button type="button" class="tys-modal__btn tys-modal__next" data-tys-mnext aria-label="Next video">' + icon('M9 5l7 7-7 7') + '</button>';
    document.body.appendChild(el);

    var m = {
      el: el,
      video: el.querySelector('[data-tys-mvideo]'),
      stage: el.querySelector('[data-tys-stage]'),
      count: el.querySelector('[data-tys-count]'),
      prev: el.querySelector('[data-tys-mprev]'),
      next: el.querySelector('[data-tys-mnext]'),
      close: el.querySelector('[data-tys-close]'),
      items: [], index: 0, owner: null, returnFocus: null
    };

    m.show = function (i) {
      var n = m.items.length;
      m.index = (i + n) % n;
      var it = m.items[m.index];
      m.video.pause();
      m.video.muted = false;
      if (it.poster) m.video.setAttribute('poster', it.poster); else m.video.removeAttribute('poster');
      m.video.src = it.src;
      m.count.textContent = n > 1 ? (m.index + 1) + ' / ' + n : '';
      m.el.setAttribute('aria-label', it.title || 'Video player');
      var p = m.video.play();
      if (p && p.catch) {
        p.catch(function () { // sound blocked (rare after a tap) -> fall back to muted, controls still available
          m.video.muted = true;
          m.video.play().catch(function () {});
        });
      }
    };
    m.open = function (owner, items, i) {
      m.owner = owner;
      m.items = items;
      m.returnFocus = document.activeElement;
      var multi = items.length > 1;
      m.prev.hidden = !multi;
      m.next.hidden = !multi;
      m.el.hidden = false;
      document.documentElement.classList.add('tys-modal-open');
      if (owner) owner.pauseAll();
      // eslint-disable-next-line no-unused-expressions
      m.el.offsetWidth; // reflow for fade-in
      m.el.classList.add('is-open');
      m.show(i);
      m.close.focus({ preventScroll: true });
    };
    m.hide = function () {
      if (m.el.hidden) return;
      m.video.pause();
      m.video.removeAttribute('src');
      m.video.load();
      m.el.classList.remove('is-open');
      m.el.hidden = true;
      document.documentElement.classList.remove('tys-modal-open');
      if (m.owner) m.owner.resume();
      if (m.returnFocus && m.returnFocus.focus) m.returnFocus.focus({ preventScroll: true });
    };
    m.isOpen = function () { return !m.el.hidden; };

    m.close.addEventListener('click', m.hide);
    m.prev.addEventListener('click', function () { m.show(m.index - 1); });
    m.next.addEventListener('click', function () { m.show(m.index + 1); });
    el.addEventListener('click', function (e) { if (e.target === el) m.hide(); });
    document.addEventListener('keydown', function (e) {
      if (!m.isOpen()) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); m.hide(); }
      else if (e.key === 'ArrowLeft' && m.items.length > 1) { e.preventDefault(); m.show(m.index - 1); }
      else if (e.key === 'ArrowRight' && m.items.length > 1) { e.preventDefault(); m.show(m.index + 1); }
      else if (e.key === 'Tab') { // focus trap
        var f = [m.close, m.prev, m.video, m.next].filter(function (x) { return !x.hidden; });
        var at = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(at + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
    // Swipe left/right = prev/next, swipe down = close
    var sx = 0, sy = 0, tracking = false;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2 && m.items.length > 1) m.show(m.index + (dx < 0 ? 1 : -1));
      else if (dy > 110 && Math.abs(dy) > Math.abs(dx) * 1.5) m.hide();
    }, { passive: true });

    modal = m;
    return m;
  }

  /* ---------------- Carousel ---------------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStories(root) {
    if (root.__tys) return;
    var track = root.querySelector('[data-tys-track]');
    var cards = qsa('[data-tys-card]', root);
    if (!track || !cards.length) return;
    var prev = root.querySelector('[data-tys-prev]');
    var next = root.querySelector('[data-tys-next]');
    var autoplay = root.getAttribute('data-autoplay') !== 'false' && !reduceMotion;
    var visible = new Set();

    var items = cards.map(function (c) {
      return { src: c.getAttribute('data-src'), poster: c.getAttribute('data-poster'), title: c.getAttribute('data-title') };
    });
    var videos = cards.map(function (c) {
      var v = c.querySelector('video');
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      return v;
    });

    function play(v) {
      if (!autoplay || (modal && modal.isOpen()) || document.hidden) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    var api = {
      pauseAll: function () { videos.forEach(function (v) { v.pause(); }); },
      resume: function () { videos.forEach(function (v) { if (visible.has(v)) play(v); }); }
    };
    root.__tys = api;

    // Only autoplay cards that are actually in view (viewport + carousel clipping).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target.querySelector('video');
          if (en.isIntersecting && en.intersectionRatio >= 0.55) { visible.add(v); play(v); }
          else { visible.delete(v); v.pause(); }
        });
      }, { threshold: [0, 0.55, 1] });
      cards.forEach(function (c) { io.observe(c); });
      api.io = io;
    } else {
      videos.forEach(function (v) { visible.add(v); play(v); });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) api.pauseAll(); else api.resume();
    });

    // Arrows
    function step() {
      var c = cards[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / (c + gap)));
      return per * (c + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max - 2;
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    window.addEventListener('resize', update);
    update();

    // Open lightbox
    cards.forEach(function (c, i) {
      var btn = c.querySelector('[data-tys-open]') || c;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        getModal().open(api, items, i);
      });
    });

    // Theme editor: bring selected block into view
    root.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest && e.target.closest('[data-tys-card]');
      if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  }

  function initAll(ctx) {
    qsa('[data-tys-delivery]', ctx).forEach(initDelivery);
    qsa('[data-tys]', ctx).forEach(initStories);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { if (modal) modal.hide(); });

  window.TellYourStory = { addBusinessDays: addBusinessDays, deliveryRange: deliveryRange, init: initAll };
})();